import { render, staticRenderFns } from "./left-fiveSelectOne.vue?vue&type=template&id=05bbf1e9&scoped=true"
import script from "./left-fiveSelectOne.vue?vue&type=script&lang=js"
export * from "./left-fiveSelectOne.vue?vue&type=script&lang=js"
import style0 from "./left-fiveSelectOne.vue?vue&type=style&index=0&id=05bbf1e9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05bbf1e9",
  null
  
)

export default component.exports